<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 公章
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form :model="query" ref="query" label-width="80px" inline="">
                    <el-form-item label="公章名称:" label-width="75px">
                        <el-input v-model="query.seal_name" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                </el-form>
            </div>
            <div class="next-box">
                <el-button
                    type="danger"
                    icon="el-icon-delete-solid"
                    @click="delAllSelection"
                >批量删除</el-button>
                 <el-button
                    type="primary"
                    icon="el-icon-circle-plus"
                    @click="addVisiable= true"
                >添加</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="seal_name" label="公章名称"  align="center"></el-table-column>
                <el-table-column prop="type" label="公章类别"  align="center"></el-table-column>
                <el-table-column prop="seal_pic" label="公章图片"  align="center">
                            <template slot-scope="scope">
                            <el-image
                                class="table-td-thumb"
                                :src="scope.row.seal_pic"
                                :preview-src-list="[scope.row.seal_pic]"
                            ></el-image>
                        </template>
                </el-table-column>
                <el-table-column  label="规格详情"  align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="lookcontent(scope.$index, scope.row)"
                        >查看详情</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                            v-if="$store.state.roleid!=5"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
         <!-- 添加弹出框 -->
        <el-dialog title="添加公章" :visible.sync="addVisiable" width="650px">
            <el-form ref="addForm" :rules="rules" :model="addForm" label-width="100px"  :inline="true" >
                <el-form-item prop="seal_name" label="公章名称">
                    <el-input v-model="addForm.seal_name"></el-input>
                </el-form-item>
                <el-form-item label="公章类别" prop="type">
                    <el-select v-model="addForm.type" filterable>
                        <el-option
                            v-for="item in typeList"
                            :key="item.id"
                            :label="item.type"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
               
                <el-form-item label="材质">
                    <el-form 
                        :inline="true"
                        :model="formData"
                        label-width="0"
                        ref="formData"
                        class="dataForm workForm"
                        a
                    >
                        <div
                            v-for="(item,index) in formData.productList"
                            :key="index"
                            style="padding: 0px;"
                        >
                            <el-form-item  :prop="'productList.' + index + '.materials'">
                                <el-input v-model="item.materials" style="width:120px" ></el-input>
                                <el-button
                                    type="danger"
                                    size="small"
                                    plain
                                    @click="removeRow(index,formData.productList)"
                                     v-if="index>=1"
                                >删除</el-button>
                            </el-form-item>

                        </div>
                        <el-button size="small" @click="addWork(formData.productList)">添加</el-button>
                    </el-form>
                </el-form-item>
                <el-form-item label="形状" label-width="90px" >
                    <el-form 
                        :model="formData1"
                        label-width="0"
                        ref="formData1"
                        class="dataForm workForm1"
                        a
                        style="margin-right:20px"
                    >
                        <div
                            v-for="(item,index) in formData1.productList"
                            :key="index"
                            style="padding: 0px;"
                        >
                            <el-form-item  :prop="'productList.' + index + '.shape'">
                                  <el-input v-model="item.shape" style="width:120px" ></el-input>
                                  <el-button
                                type="danger"
                                size="small"
                                plain
                                @click="removeRow(index,formData1.productList)"
                                v-if="index>=1"
                            >删除</el-button>
                            </el-form-item>
                        </div>
                         <el-button size="small" @click="addWork1(formData1.productList)">添加</el-button>
                        </el-form>
                </el-form-item>
                <el-button type="primary" @click="getPricetable()" style="margin-left:30px">生成规格表</el-button>
                    <el-table
                        :data="tableDataPrice"
                        style="margin-bottom:20px;">
                        <el-table-column prop="materials" label="材质"  align="center"></el-table-column>
                        <el-table-column prop="shape" label="形状"  align="center"></el-table-column>
                        <el-table-column prop="money" label="价格"  align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.money" ></el-input>
                            </template>
                        </el-table-column>
                         <el-table-column prop="inventory" label="数量"  align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.inventory"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                     <el-form-item label="公章图片" prop="seal_pic"  >
                    <el-upload
                        :limit="1"
                        action="http://localhost:9999/cat/adopt/insertAdopt"
                        ref="uploadimg"
                        list-type="picture-card"
                        :auto-upload="false"
                        :data="addForm"
                        :file-list="addForm.seal_pic"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :http-request="uploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisiable = false">取 消</el-button>
                <el-button type="primary" @click="addData()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑弹出框 -->
        <el-dialog title="编辑公章" :visible.sync="editVisible" width="500px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="100px" >
                <el-form-item prop="seal_name" label="公章名称">
                    <el-input v-model="editForm.seal_name"></el-input>
                </el-form-item>
                <el-form-item label="公章类别" prop="type">
                    <el-select v-model="editForm.type" filterable>
                        <el-option
                            v-for="item in typeList"
                            :key="item.id"
                            :label="item.type"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="公章图片" prop="logoarray">
                    <el-upload
                        :limit="1"
                        action="http://localhost:9999/cat/adopt/insertAdopt"
                        ref="uploadimg1"
                        list-type="picture-card"
                        :auto-upload="false"
                        :data="editForm"
                        :file-list="editForm.logoarray"
                        :on-remove="handleRemove1"
                        :on-change="handleChange1"
                        :http-request="uploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false;resetForm('editForm')">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>
         <!-- 编辑规格 -->
        <el-dialog title="编辑公章规格" :visible.sync="contentEditVisiable" width="500px">
            <el-form ref="ContenteditForm" :rules="rules" :model="ContenteditForm" label-width="100px" >
                <el-form-item prop="materials" label="公章材质">
                    <el-input v-model="ContenteditForm.materials"></el-input>
                </el-form-item>
               
                <el-form-item prop="shape" label="公章形状">
                     <el-input v-model="ContenteditForm.shape"></el-input>
               </el-form-item>
                <el-form-item prop="money" label="价格">
                     <el-input v-model="ContenteditForm.money"></el-input>
                </el-form-item>
                 <el-form-item prop="inventory" label="库存">
                     <el-input v-model="ContenteditForm.inventory"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="contentEditVisiable = false">取 消</el-button>
                <el-button type="primary" @click="saveContentEdit()">确 定</el-button>
            </span>
        </el-dialog>
         <!-- 规格详情 -->
        <el-dialog title="规格详情" :visible.sync="contentVisiable" width="800px">
            <el-button type="primary" @click="addShapeVisiable = true">添加形状</el-button>
            <el-button type="primary" style="margin-bottom:10px" @click="addMaterialVisiable=true">添加材质</el-button>
            <el-table
                :data="contentData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                height="400px"
            >
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="materials" label="公章材质"  align="center"></el-table-column>
                <el-table-column prop="shape" label="公章形状"  align="center"></el-table-column>
                <el-table-column prop="money" label="公章价格"  align="center"></el-table-column>
                <el-table-column prop="inventory" label="公章库存"  align="center"></el-table-column>
                <el-table-column label="操作" width="300" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEditContent(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDeleteContent(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="添加材质" :visible.sync="addMaterialVisiable" width="800px">
            <el-form ref="addModelForm"  :model="addModelForm" label-width="100px"  :inline="true" >
                <el-form-item label="材质">
                    <el-form 
                        :inline="true"
                        :model="materialFormData"
                        label-width="0"
                        ref="materialFormData"
                        class="dataForm workForm"
                        a
                    >
                        <div
                            v-for="(item,index) in materialFormData.list"
                            :key="index"
                            style="padding: 0px;"
                        >
                            <el-form-item  :prop="'list.' + index + '.materials'">
                                <el-input v-model="item.materials" style="width:120px" ></el-input>
                                <el-button
                                    type="danger"
                                    size="small"
                                    plain
                                    @click="removeRow(index,materialFormData.list)"
                                     v-if="index>=1"
                                >删除</el-button>
                            </el-form-item>

                        </div>
                        <el-button size="small" @click="addWork2(materialFormData.list)">添加</el-button>
                    </el-form>
                </el-form-item>
                
                <el-button type="primary" @click="getTable(rowid)" style="margin-left:100px">生成规格表</el-button>
                    <el-table
                        :data="shapeData"
                        style="margin-bottom:20px;">
                        <el-table-column prop="materials" label="材质"  align="center"></el-table-column>
                        <el-table-column prop="shape" label="形状"  align="center"></el-table-column>
                        <el-table-column prop="money" label="价格"  align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.money" ></el-input>
                            </template>
                        </el-table-column>
                         <el-table-column prop="inventory" label="数量"  align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.inventory"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
              
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addMaterialVisiable = false">取 消</el-button>
                <el-button type="primary" @click="saveAdd()">确 定</el-button>
            </span>
            
        </el-dialog>
         <el-dialog title="添加形状" :visible.sync="addShapeVisiable" width="800px">
            <el-form ref="addModelForm"  :model="addModelForm" label-width="100px"  :inline="true" >
                <el-form-item label="形状">
                    <el-form 
                        :inline="true"
                        :model="shapeFormData"
                        label-width="0"
                        ref="shapeFormData"
                        class="dataForm workForm"
                        a
                    >
                        <div
                            v-for="(item,index) in shapeFormData.list"
                            :key="index"
                            style="padding: 0px;"
                        >
                            <el-form-item  :prop="'list.' + index + '.shape'">
                                <el-input v-model="item.shape" style="width:120px" ></el-input>
                                <el-button
                                    type="danger"
                                    size="small"
                                    plain
                                    @click="removeRow(index,shapeFormData.list)"
                                     v-if="index>=1"
                                >删除</el-button>
                            </el-form-item>

                        </div>
                        <el-button size="small" @click="addWork1(shapeFormData.list)">添加</el-button>
                    </el-form>
                </el-form-item>
                
                <el-button type="primary" @click="getTable1(rowid)" style="margin-left:100px">生成规格表</el-button>
                    <el-table
                        :data="shapeData"
                        style="margin-bottom:20px;">
                        <el-table-column prop="materials" label="材质"  align="center"></el-table-column>
                        <el-table-column prop="shape" label="形状"  align="center"></el-table-column>
                        <el-table-column prop="money" label="价格"  align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.money" ></el-input>
                            </template>
                        </el-table-column>
                         <el-table-column prop="inventory" label="数量"  align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.inventory"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
              
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addShapeVisiable = false">取 消</el-button>
                <el-button type="primary" @click="saveAdd()">确 定</el-button>
            </span>
            
        </el-dialog>
    </div>
</template>

<script>


import { post } from '../../../api/request';

export default {
    name: 'basetable',
    data() {
        return {
            // 添加规格和添加材质
            addShapeVisiable:false,
            addMaterialVisiable:false,
            addModelForm:{
                shape:"",
                material:""
            },
            shapeData:[],
            shapeFormData: {
                list: [
                    { shape:'',}
                ]
            },
            materialFormData: {
                list: [
                    { materials:'',}
                ]
            },

            contentData:[],
            contentVisiable:false,
            contentEditVisiable:false,
            ContenteditForm:{},
            tableDataPrice:[],
            formData: {
                productList: [
                    { materials:'',}
                ]
            },// 动态表单
            workForm: {
                material: '',   
            },
            formData1: {
                productList: [
                    { shape:'',}
                ]
            },// 动态表单
            workForm1: {
                shape: '',   
            },
            upvisiable:false,
            fileList:[],
            formdata:'',
            //公章图片
            url:'',
            hideUpload: false,
            dialogImageUrl: '',
            dialogVisible: false,//图片预览弹窗
            formLabelWidth: '80px',
            limitNum: 1,
            form: {},
            dialogVisible2: false,//弹窗
            //材质，类别，形状列表
            materialsList:[],
            typeList:[],
            shapeList:[],
            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
            query: {
                seal_name: '',
                pageIndex: 1,
                pageSize: 6
            },
            pageTotal: 7,
            //添加数据
            addVisiable:false,
            addForm:{
               seal_name:'',
               materials:'',
               shape:'',
               money:'',
               inventory:'',
               type:'',
               seal_pic:[],
            },
            //编辑数据
            editVisible:false,
            editForm:{},
            //添加数据表单验证
            rules: {
                seal_name: [
                    { required: true, message: '请输入公章名称', trigger: 'blur' },
                ],
                type: [
                    { required: true, message: '请选择公章类别', trigger: 'blur' },
                ],
                materials: [
                    { required: true, message: '请选择公章材质', trigger: 'blur' },
                ],
                shape: [
                    { required: true, message: '请选择公章形状', trigger: 'blur' },
                ],
                money: [
                    { required: true, message: '请输入公章价格', trigger: 'blur' },
                ],
                inventory: [
                    { required: true, message: '请输入公章库存', trigger: 'blur' },
                ],
                seal_pic: [
                    { required: true, message: '请选择图片', trigger: 'blur' },
                ]
               
            },
            //批量删除
            multipleSelection: [],
            delList: [],
            //获取id
            idx: -1,
            id: -1,
            rowid:''  //当前行id
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.getList()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.getList()
    },
    methods: {
        // 获取规格表单个参数
        getTable(id){
            let formdata  = new FormData()
            formdata.append("seal_id",id)
            formdata.append("materials",JSON.stringify(this.materialFormData.list))
            formdata.append("shape","")
            post("admin/seal/inimodel",formdata).then(res=>{
                    this.shapeData = res.data.data
            })
        },
        getTable1(id){
             let formdata  = new FormData()
            formdata.append("seal_id",id)
            formdata.append("materials","")
            formdata.append("shape",JSON.stringify(this.shapeFormData.list))
            post("admin/seal/inimodel",formdata).then(res=>{
                    this.shapeData = res.data.data
            })
        },
        saveAdd(){
            let formdata = new FormData()
            formdata.append("seal_id",this.rowid)
            formdata.append("ret",JSON.stringify(this.shapeData))
            post("admin/seal/inimodel1",formdata).then(res=>{
                if(res.data.msg =="添加成功"){
                    this.addMaterialVisiable = false;
                    this.addShapeVisiable = false;
                    let form = new FormData()
                    form.append("id",this.rowid)
                    post("admin/Seal/selmodel",form).then(res=>{
                        this.contentData = res.data.data
                    })
                    this.$message.success("添加成功"),
                    this.$refs['shapeFormData'].resetFields();
                    this.$refs['materialFormData'].resetFields();
                    this.shapeData=[]
                } 
            })
        },
        handleEditContent(index,row){
            this.ContenteditForm = Object.assign({}, row);
            this.contentEditVisiable = true
        },
        saveContentEdit(){
            let formdata = new FormData()
            let formdata1 = new FormData()
            formdata1.append("id",this.rowid)
            formdata.append("id",this.ContenteditForm.id)
            formdata.append("materials",this.ContenteditForm.materials)
            formdata.append("shape",this.ContenteditForm.shape)
            formdata.append("money",this.ContenteditForm.money)
            formdata.append("inventory",this.ContenteditForm.inventory)
            post("admin/Seal/updmodel",formdata).then(res=>{
                if(res.data.msg =="修改成功"){
                    this.$message.success("修改成功")
                    this.contentEditVisiable =false;
                    post("admin/Seal/selmodel",formdata1).then(res=>{
                        this.contentData = res.data.data
                    })
                }
                else{
                    this.$message.error("修改失败")
                }
            })
        },
        handleDeleteContent(index,row){
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                   let formdata = new FormData()
                    formdata.append("id",row.id)
                    let formdata1 = new FormData()
                    formdata1.append("id",this.rowid)
                    post("admin/Seal/delmodel",formdata).then(res=>{
                        if(res.data.msg=="删除成功")
                        {
                            this.$message.success("删除成功")
                            post("admin/Seal/selmodel",formdata1).then(res=>{
                                this.contentData = res.data.data
                            })
                        }
                    
                    })
                })
                .catch(() => {});
        },
        lookcontent(index,row){
            this.contentVisiable = true
            let formdata = new FormData()
            this.rowid = row.id
            formdata.append("id",row.id)
            post("admin/Seal/selmodel",formdata).then(res=>{
                this.contentData = res.data.data
            })
        },
        getPricetable(){
            let formdata = new FormData()
            var json1 = JSON.stringify(this.formData.productList)
            var json2 = JSON.stringify(this.formData1.productList)
            formdata.append('materials',json1)
            formdata.append('shape',json2)
            post("admin/Seal/addmodel",formdata).then(res=>{
                this.tableDataPrice = res.data.data
            })
        },
        addWork2(list) {
            list.push({
                materials:'',
            })
        },
        addWork(list) {
            list.push({
                materials:'',
            })
        },
        addWork1(list) {
            list.push({
                shape:'',
            })
        },
        // 删除属性列
        removeRow(index,list) {
            list.splice(index, 1)
        },
        removeImage(file, fileList){
            const tmp_path  = file.response
            if(fileList.length < 1) {
                 this.uploadDisabled = true //未选择文件则禁用上传按钮
             }
        },
        handleChange (file, fileList) {
            this.addForm.seal_pic = fileList;
        },
        handleRemove(file, fileList) {
            this.addForm.seal_pic = fileList;
        },
        handleChange1 (file, fileList) {
            this.editForm.logoarray = fileList;
        },
        handleRemove1(file, fileList) {
            this.addForm.logoarray = fileList;
        },
        handlePictureCardPreview(file) {
            this.adoptFormdialogImageUrl = file.url;
            this.adoptFormdialogVisible = true;
        },
        uploadFile(file){
            this.upvisiable = true
            this.formdata.append('file', file.file);
        },
        beforeUpload(file) {
            let _this = this;
            let _checkSize = false;  //是否需要指定上传图片的尺寸
            if(file.size > 1024*500) {  //大小超过500kb
                _this.$message.error('图片太大，请重新选择');
                return false;
            }
            const isSize = new Promise((resolve, reject)=>{
                let _URL = window.URL || window.webkitURL;
                let img = new Image();
                img.onload = function () {
                    if(!_checkSize || (_checkSize && img.width==_this.imgWidth && img.height==_this.imgHeight)) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                }
                img.src = _URL.createObjectURL(file);
            }).then(()=>{
                return file;
            },()=>{
                _this.$message.error('图片尺寸不对，请重新选择');
                return Promise.reject();
            });
            return isSize;
        }  ,
       
        getList(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            post('admin/seal/seaShape',formdata).then(res => {
                if(res.code=200){
                    this.shapeList = res.data.data;
                }
            });
            post('admin/seal/seaMeta',formdata).then(res => {
                if(res.code=200){
                    this.materialsList = res.data.data;
                }
            });
            post('admin/seal/sealinfo',formdata).then(res => {
                if(res.code=200){
                    this.typeList = res.data.data.list;
                }
            });
        },
        addData(url1){
            this.formdata = new FormData()
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            this.$refs.uploadimg.submit();
            this.$refs['addForm'].validate((valid) => {
            if (valid) {
                 post("/admin/file/url",this.formdata,config).then( res => {
                    this.formdata = new FormData()
                    this.formdata.append('seal_name',this.addForm.seal_name)
                    this.formdata.append('type_id',this.addForm.type)
                    this.formdata.append('company_id',this.companyid)
                    this.formdata.append('seal_pic',res.data)
                    var json1 =JSON.stringify(this.tableDataPrice)
                    this.formdata.append('ret',json1)
                    post('admin/Seal/addseal',this.formdata).then(res=>{
                        if(res.data.msg =="添加成功"){
                            this.upvisiable = false
                            this.$message.success("添加成功")
                            this.getData()
                            this.$refs['addForm'].resetFields();
                            this.$refs['formData'].resetFields();
                            this.$refs['formData1'].resetFields();
                            this.formData.productList.length = 1
                            this.formData1.productList.length = 1
                            this.tableDataPrice = []
                            this.addVisiable = false 
                            if (!this.tableData.length && this.query.pageIndex > 1) {
                                this.query.pageIndex--;
                                this.getData()
                            }
                    }
                    else{
                        this.$messaga.error("添加失败")
                    }          
                })
            })
               
            }
        })
        },
        updateStatus(index,row){
            let formdata = new FormData()
            let url = 'admin/admin_user/disables'
            formdata.append('id',row.id)
            if(row.disable==1){
                url = 'admin/admin_user/starts'
            }
            post(url,formdata).then(res=>{
                if(res.data.msg =="禁用失败"){
                    this.$message.error("禁用失败")
                } 
                else if(res.data.msg =="禁用成功"){
                    this.$message.success("禁用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用成功"){
                    this.$message.success("启用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用失败"){
                    this.$message.error("启用失败")
                    this.getData()
                }      
            })
        },
        //重置表单
        resetForm(formName) {
            this.$refs['editForm'].resetFields();
            this.$refs[formName].resetFields();
            console.log(this.editForm)
        },
        //重置搜索
        resetsearch(){
            this.query.seal_name= '',
            this.getData()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('seal_name',this.query.seal_name)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            post('admin/seal/types',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                    }
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('seal_name',this.query.seal_name)
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            post('admin/seal/types',formdata).then(res => {
                if(res.data.data.list){
                    this.tableData = res.data.data.list
                }
            });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    post('admin/seal/deleseal',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                            this.getData()
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].id + ',';
            }
            let formdata = new FormData()
            formdata.append('id',str)
            post('admin/seal/alldeleSeal',formdata).then(res=>{
                if(res.data.msg == "删除成功"){
                    this.multipleSelection = [];
                    this.$message.success('删除成功')
                    this.getData()
                }
                else{
                    this.$message.error('删除失败')
                }
            })
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            let array = [{
                url:'',
                name:'1'
            }]
            array[0].url =this.editForm.seal_pic
            this.editForm.logoarray=array
            for(let i =0;i<this.materialsList.length;i++){
                if(this.materialsList[i].materials == this.editForm.materials)
                {
                    this.editForm.materials =  this.materialsList[i].id
                }
            }
            for(let i =0;i<this.shapeList.length;i++){
                if(this.shapeList[i].shape == this.editForm.shape)
                {
                    this.editForm.shape =  this.shapeList[i].id
                }
            }
            for(let i =0;i<this.typeList.length;i++){
                if(this.typeList[i].type == this.editForm.type)
                {
                    this.editForm.type =  this.typeList[i].id
                }
            }
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.formdata = new FormData()
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            this.$refs.uploadimg1.submit();
            this.$refs['editForm'].validate((valid) => {
            if (valid) {
                if(this.upvisiable){
                    post("/admin/file/url",this.formdata,config).then( res => {
                    this.upvisiable = false
                    let formdata = new FormData()
                    formdata.append('id',this.editForm.id)
                    formdata.append('seal_name',this.editForm.seal_name)
                    formdata.append('type_id',this.editForm.type)
                    formdata.append('seal_pic',res.data)
                    formdata.append('company_id',this.companyid)
                    post('admin/seal/updaseal',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                    
                })
                }
                else{
                    let formdata = new FormData()
                    formdata.append('id',this.editForm.id)
                    formdata.append('seal_name',this.editForm.seal_name)
                    formdata.append('seal_pic',this.editForm.seal_pic)
                    formdata.append('shape',this.editForm.shape)
                    formdata.append('type_id',this.editForm.type)
                    post('admin/seal/updaseal',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                }
            }
            })             
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}
</style>
